module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Mountain-2ebb0be2285d81d69fa71d9b4c827b4e.svg";